type VehicleApiItem = {
  frota?: string | null;
  grupoID?: number;
  razaoSocial?: string;
  nomeFantasia?: string;
  CNPJ?: string;
  placa?: string;
  chassi?: string;
  Chassi?: string;
  numeroSerie?: string;
  NumeroSerie?: string;
  renavam?: string;
  codigoFipe?: string;
  marca?: string;
  modelo?: string;
  versao?: string | null;
  anoFabricacao?: number;
  anoModelo?: number;
  combustivel?: string | null;
  veiculoReserva?: string | null;
  dataImplantacao?: string;
  dataFinalVigencia?: string;
};

type VehicleApiResponse = {
  data?: VehicleApiItem[];
  ultimaPagina?: number;
  total?: number;
};

export const pickVehicleSerialNumber = (
  dto: Pick<VehicleApiItem, 'numeroSerie' | 'NumeroSerie'> & {
    serialNumber?: string;
  },
) =>
  dto.serialNumber || dto.numeroSerie || dto.NumeroSerie || '';

export const mapVehicleApiItem = (dto: VehicleApiItem): TableVehicleListItem => ({
  fleet: dto.frota ?? '',
  groupId: dto.grupoID ?? 0,
  legalName: dto.razaoSocial ?? '',
  tradeName: dto.nomeFantasia ?? '',
  cnpj: dto.CNPJ ?? '',
  plate: dto.placa ?? '',
  chassis: dto.chassi ?? dto.Chassi ?? '',
  serialNumber: pickVehicleSerialNumber(dto),
  renavam: dto.renavam ?? '',
  fipeCode: dto.codigoFipe ?? '',
  brand: dto.marca ?? '',
  model: dto.modelo ?? '',
  version: dto.versao ?? '',
  manufacturingYear: dto.anoFabricacao ?? 0,
  modelYear: dto.anoModelo ?? 0,
  fuelType: dto.combustivel ?? '',
  reserveVehicle: dto.veiculoReserva ?? '',
  implementationDate: dto.dataImplantacao ?? '',
  expirationDate: dto.dataFinalVigencia ?? '',
});

export const mapVehicleApiResponse = (
  response?: VehicleApiResponse | null,
): TableVehicleData => ({
  itens: (response?.data ?? []).map(mapVehicleApiItem),
  pageCount: response?.ultimaPagina ?? 0,
  rows: response?.total ?? 0,
});

export const normalizeVehicleListItem = (
  item: TableVehicleListItem & {
    numeroSerie?: string;
    NumeroSerie?: string;
  },
): TableVehicleListItem => {
  const serialNumber =
    item.serialNumber ||
    item.numeroSerie ||
    item.NumeroSerie ||
    '';

  return {
    ...item,
    serialNumber,
  };
};

export const normalizeVehicleList = (
  items: TableVehicleListItem[] = [],
): TableVehicleListItem[] => items.map(normalizeVehicleListItem);
